import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import About from "./components/About";
import PropuestaDeValorSection from "./components/PropuestaDeValorSection";
import QuienSoySection from "./components/QuienSoySection";
import Testimonial from "./components/Testimonial";
import Interactive3DSection from "./components/Interactive3DSection";
import Footer from "./components/Footer";
import Copyright from "./components/Copyright";
import SuscripcionSection from "./components/SuscripcionSection";
import VideoSection from "./components/VideoSection";
import MiddleSection from "./components/MiddleSection";
import ContratarSection from "./components/ContratarSection";
import Empresas from "./components/Empresas";
import WhatsAppButton from "./components/WhatsAppButton";
import BlogErnesto from "./BlogErnesto";
import NewScreen from "./NewScreen";
import BlogPostPage from "./components/BlogPost/BlogPostPage";
import FaqIA from "./components/FaqIA";

// 🔹 Datos del evento Online y Presencial
const ciudades = {
  presencial: {
    nombre: "Presencial",
    fecha: "10 de Diciembre de 2025 / Panamá",
    modalidad: "Presencial Panamá",
    descripcion:
      "Evento presencial exclusivo para clientes de MATCO INT. Conferencia & Taller interactivo, networking y demostraciones reales de IA aplicada a la SST.",
    imagen:
      "https://esgrymaconsulting.com/wp-content/uploads/2025/12/ernesto.jpeg",
    textoExtra:
      "EVENTO EXCLUSIVO PARA CLIENTES DE MATCO INT.   Participa en una jornada inmersiva donde aplicarás IA en vivo y tendrás contacto directo con expertos del sector."
  },

  online: {
    nombre: "Online",
    fecha: "31 de Enero de 2026",
    modalidad: "Online",
    descripcion:
      "Evento online exclusivo desde plataforma virtual. Accede desde cualquier lugar y aprende con expertos.",
    imagen:
      "https://esgrymaconsulting.com/wp-content/uploads/2025/12/LOGO1.png",
    textoExtra:
      "Conéctate desde cualquier dispositivo y vive una experiencia formativa única con IA aplicada a la SST."
  }
};

const HomePage = () => {
  return (
    <div>
      <VideoSection />
      <MiddleSection />
      <About />
      <QuienSoySection />
      <PropuestaDeValorSection />
      <SuscripcionSection />
      <Empresas />
      <Interactive3DSection />
      <Testimonial />
      <ContratarSection />
      <FaqIA />
      <Footer />
      <Copyright />
      <WhatsAppButton />
    </div>
  );
};

const App = () => {
  const [showModal, setShowModal] = useState(false);

  // Presencial por defecto
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState("presencial");

  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  return (
    <div className="max-w-[1920px] mx-auto overflow-hidden bg-white">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Biografia" element={<NewScreen />} />
        <Route path="/blogernesto" element={<BlogErnesto />} />
        <Route path="/blog/post/:slug" element={<BlogPostPage />} />
      </Routes>

      {/* Botón flotante inferior izquierdo */}
      <div className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50">
        <button
          onClick={() => setShowModal(true)}
          className="bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-500 p-[2px] sm:p-[3px] rounded-full animate-pulse-slow hover:scale-105 transition-all"
        >
          <div className="bg-black rounded-full px-4 py-2 sm:px-6 sm:py-3 text-white font-bold text-xs sm:text-sm tracking-wide">
            ¡PRÓXIMA FECHA DEL EVENTO!
          </div>
        </button>
      </div>

      {/* MODAL */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-2 sm:p-4"
          onClick={() => setShowModal(false)}
        >
          <div
            className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto bg-[#0a0a0a] text-white rounded-2xl border-2 border-purple-500 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Botón cerrar */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-2 text-white text-3xl font-bold hover:text-red-400"
            >
              ×
            </button>

            {/* Selector Presencial / Online */}
            <div className="absolute top-2 left-1/2 -translate-x-1/2 flex gap-2 z-50">
              <button
                onClick={() => setCiudadSeleccionada("presencial")}
                className={`px-4 py-1 rounded-full font-bold shadow-md transition ${
                  ciudadSeleccionada === "presencial"
                    ? "bg-white text-black"
                    : "bg-gray-700 text-white"
                }`}
              >
                Presencial
              </button>

              <button
                onClick={() => setCiudadSeleccionada("online")}
                className={`px-4 py-1 rounded-full font-bold shadow-md transition ${
                  ciudadSeleccionada === "online"
                    ? "bg-white text-black"
                    : "bg-gray-700 text-white"
                }`}
              >
                Online
              </button>
            </div>

            {/* ⭐ IMAGEN SIN RECORTES ⭐ */}
            <div className="w-full h-[380px] sm:h-[420px] flex items-center justify-center bg-black rounded-t-xl">
              <img
                src={ciudades[ciudadSeleccionada].imagen}
                alt="Evento IA SST"
                className="max-w-full max-h-full object-contain"
              />
            </div>

            {/* Contenido */}
            <div className="px-4 py-4 text-center space-y-3">
              <p className="text-sm sm:text-base leading-relaxed">
                🔥{" "}
                <strong>
                  {ciudadSeleccionada === "online"
                    ? "¡Taller Revolución IA en SST – Online!"
                    : `¡Conferencia IA Que salva vidas – ${ciudades[ciudadSeleccionada].nombre}!`}
                </strong>{" "}
                🔥
                <br />
                {ciudades[ciudadSeleccionada].descripcion}
              </p>

              <p className="text-sm sm:text-base">
                📅 <strong>{ciudades[ciudadSeleccionada].fecha}</strong>
                <br />
                {ciudades[ciudadSeleccionada].modalidad === "Online"
                  ? "Evento 100% online, accede desde donde estés."
                  : "Evento presencial de alta experiencia e interacción real."}
              </p>

              <p className="text-sm sm:text-base">
                💡 {ciudades[ciudadSeleccionada].textoExtra}
              </p>

              <a
                href="https://revolucion--ia-sst.ernestomora.com/#pricing"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-sm sm:text-base border border-cyan-300 text-white px-6 py-2 rounded-full hover:bg-cyan-600 transition font-semibold"
              >
                ¡QUIERO ASISTIR!
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
